import axios from 'axios'
import ElementUI from 'element-ui';
import router from '@/router';
import global from '@/global';
// 引入QS格式化数据
import qs from 'qs'
// 引入公共方法


// 创建新的axios实例
const instance = axios.create({
  baseURL: global.http,
  // 超时时间 单位是ms，这里设置了20s的超时时间
  timeout: 20 * 1000,
  withCredentials: true,
  // headers: {
  //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  //     "Content-Type": "multipart/form-data",
  // }
})

//响应拦截
instance.interceptors.response.use(
  function (response) {
    // 在接收响应做些什么，例如跳转到登录页
    if (response.data.code == 401) {
      ElementUI.Notification({
        title: '请您重新登陆',
        message: '当前用户已在其他设备登陆,',
        type: 'warning',
      });
      window.localStorage.clear();
      router.push({ path: "/" });
    } else if (response.data.code == 403) {
      return resError(response);
    } else if (response.data.code == 500) {
      return resError(response);
    }
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    return resError(error);
  }
)

function resError(response) {
  ElementUI.Message({
    showClose: true,
    message: response.data.msg,
    type: 'error'
  });
  return Promise.reject(response);
}

// 封装GET请求
export function get(url, params) {
  params['token'] = localStorage.getItem('token');
  params['loginUserId'] = localStorage.getItem("useId");
  return instance.get(url, {
    params
  });
}

// 封装put请求
export function put(url, params) {
  params['token'] = localStorage.getItem('token');
  params['loginUserId'] = localStorage.getItem("useId");
  return instance.put(url, params);
}

// 封装DELETE请求
export function deleteNo(url, params) {
  return instance.delete(url, params);
}

// 封装POST请求
export function post(url, data) {

  data['token'] = localStorage.getItem("token");
  data['loginUserId'] = localStorage.getItem("useId");
  return instance.post(url, qs.stringify((data)));
}

// 封装postNo请求
export function postNo(url, data) {
  data['token'] = localStorage.getItem("token");
  data['loginUserId'] = localStorage.getItem("useId");
  return instance.post(url, data);
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 添加日期范围
export function addDateRange(params, dateRange) {
  if (dateRange != null && dateRange !== '') {
    params.beginTime = this.dateRange[0]
    params.endTime = this.dateRange[1]
  }
  return params
}

// 获取指定日期的那一周的开始、结束日期
export function getWeekStartAndEnd(val) {
  let now;
  if (val) {
    now = new Date(val); // 日期
  } else {
    now = new Date(); // 日期
  }
  let nowDayOfWeek = now.getDay(); // 本周的第几天
  let nowDay = now.getDate(); // 当前日
  let nowMonth = now.getMonth(); // 当前月
  let nowYear = 1900 + now.getYear(); // 当前年
  let weekStart = getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek)
  let weekEnd = getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek)
  return [weekStart, weekEnd];
}
// 获得某一周的开始日期
export function getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
  let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek)
  return parseTime(weekStartDate, '{y}-{m}-{d}')
}
// 获得某一周的结束日期
export function getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
  let weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
  return parseTime(weekEndDate, '{y}-{m}-{d}')
}

export const CONSTANTS = {
  alarmStatus: [
    { name: "待指派", value: 1 },
    { name: "正在处理", value: 2 },
    { name: "无法处理", value: 3 },
    { name: "复核中", value: 4 },
    { name: "已结束", value: 5 },
    { name: "打卡工单", value: 6 },
    { name: "草稿", value: 20 },
  ]
}




// WEBPACK FOOTER //
// ./src/requests.js